<div style="padding: 15px;background-color: #f7f7f7;border-radius: 5px;">
    <p style="color: #f74343;font-weight: 700;font-size: 1.5rem;">We are performing scheduled maintenance</p>
    <p>We will be back online shortly.Please check back later.</p>
    <p>Sincerely,</p>
    <p>Berkley Fire & Marine Support</p>
</div>
